import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromotionRepository } from '@/core/domain/promotions/respository/promotion.repository';
import { GetPromotionsUseCase } from '@/core/domain/promotions/usecases/getPromotions.usecase';
import { PromotionImplRepository } from './promotion-impl.respository';

const getPromotionsDataUseCaseFactory = (
    promotionRepository: PromotionRepository,
) => new GetPromotionsUseCase(promotionRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetPromotionsUseCase,
            useFactory: getPromotionsDataUseCaseFactory,
            deps: [PromotionRepository],
        },
        {
            provide: PromotionRepository,
            useClass: PromotionImplRepository,
        },
    ],
})
export class PromotionDataModule {}
